import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { ScheduledEntry } from "@roman/shared/types/Schedule";
import { useEffect } from "react";
import useSWR from "swr";

interface RoundEntryUnitResultResponse {
  entries: ScheduledEntry[];
}

const fetcher = (url: string) => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<RoundEntryUnitResultResponse>(url, undefined, { headers });
};

export const useScheduledUserEntries = (
  userId: string | undefined,
  roundEntryUnitId: string,
  handleError: (error: RomanApiError) => void,
) => {
  const { data, error, isLoading, mutate } = useSWR<RoundEntryUnitResultResponse>(
    `/soccer/scheduled/${roundEntryUnitId}/${userId}`,
    fetcher,
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  useEffect(() => {
    mutate();
  }, [mutate]);

  return {
    data,
    isLoading,
    error,
  };
};
